import React from "react";
import { ExternalLink } from "lucide-react";

const COPY = {
  columns: ["Name", "Title", "Email", "Location", "Twitter", "LinkedIn"],
  link: "Link here",
  empty: "No users to show.",
  none: "—",
};

// Profile links are optional on the user record, so render a dash rather than
// an anchor that goes nowhere.
const ProfileLink = ({ href }) => {
  if (!href) return <span className="admin-table-muted">{COPY.none}</span>;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="admin-table-link"
    >
      {COPY.link}
      <ExternalLink size={13} />
    </a>
  );
};

export default function UserDataAdmin({ driverData }) {
  const users = (driverData || []).filter(
    (item) => item.verifieduser === true && item.category === "user"
  );

  return (
    <div className="admin-table-card">
      <div className="admin-table-scroll">
        <table className="admin-table">
          <thead>
            <tr>
              {COPY.columns.map((column) => (
                <th key={column}>{column}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr key={user._id}>
                <td className="admin-table-strong">{user.fullName}</td>
                <td>{user.title || COPY.none}</td>
                <td>{user.email}</td>
                <td>{user.location || COPY.none}</td>
                <td>
                  <ProfileLink href={user.twitter} />
                </td>
                <td>
                  <ProfileLink href={user.linkedIn} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {users.length === 0 && <p className="admin-table-empty">{COPY.empty}</p>}
    </div>
  );
}
